import { writable } from "svelte/store";

export const time = writable(0);
export const mode = writable("loading");
export const scrollZ = writable(0);
export const progress = writable(0);
export const activePlanet = writable(undefined);
export const showPopup = writable(false);
export const adOpen = writable(false);
export const audioActive = writable(null);
export const audioEl = writable(null);
export const audioCtx = writable(null);
export const categoryIndex = writable(0);
export const selectedAudience = writable(undefined);
export const muted = writable(false);
export const abouted = writable(false);
export const loaded = writable(0);
export const tip = writable({ x: 0, y: 0 });
export const drifter = writable(null);
export const audienceOpen = writable(false);
